import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorId = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M22.75 17A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17V7A2.75 2.75 0 0 1 4 4.25h16A2.75 2.75 0 0 1 22.75 7v10ZM20 18.25c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h16Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M7.8 10.5a1.2 1.2 0 1 1 1.207 1.2h-.014A1.2 1.2 0 0 1 7.8 10.5Zm-.543 1.65a2.4 2.4 0 1 1 3.487 0A3.599 3.599 0 0 1 12.6 15.3a.6.6 0 0 1-1.2 0 2.4 2.4 0 0 0-2.392-2.4h-.016A2.4 2.4 0 0 0 6.6 15.3a.6.6 0 0 1-1.2 0 3.6 3.6 0 0 1 1.857-3.15ZM17.6 10a.6.6 0 0 1-.6.6h-2a.6.6 0 1 1 0-1.2h2a.6.6 0 0 1 .6.6Zm.4 3.6a.6.6 0 0 0 0-1.2h-3a.6.6 0 0 0 0 1.2h3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorId;
